<template>
    <v-card :elevation="1" class="fill-height" width="100%">
        <div id="gjs" style="height:100%; overflow:hidden;"></div>

        <v-dialog v-model="dialog" max-width="1600px">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Seleziona un modello esistente</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-0">
                    <v-container class="pa-2" fluid>
                        <v-slide-group
                            v-model="templateSelected"
                            class="pa-4"
                            show-arrows
                            style="height: 300px">
                            <v-slide-item
                                v-for="(template, d) in defaultTemplates"
                                :key="d"
                                v-slot:default="{ active, toggle }">
                                <v-card
                                    elevation="5"
                                    color="white"
                                    class="ma-4"
                                    height="200"
                                    width="140"
                                    @click="toggle">                             
                                    <v-row class="fill-height ma-0" align="center" justify="center" :style="{'background-image': 'url(' + template.options.skeleton + ')'}" style="background-size: cover !important; background-position: center !important;">
                                        <v-scale-transition>
                                            <v-icon
                                                v-if="active"
                                                color="primary"
                                                size="48"
                                                v-text="'cancel'"
                                            ></v-icon>
                                        </v-scale-transition>
                                    </v-row>
                                    <div class="mt-2 caption" style="word-break: break-word; text-align: center;">{{ template.name }}</div>
                                </v-card>
                            </v-slide-item>
                        </v-slide-group>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="px-2">
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click.native.stop="closeDialog()">Chiudi</v-btn>
                    <v-btn :disabled="templateSelected == null" color="info" text @click.native="confirmSelected()">Seleziona</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmDialog" max-width="600px">
            <v-card class="flex pa-0 background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Seleziona un modello esistente</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text style="min-height: 100px;" class="pt-4 body-2">
                    Vuoi usare il modello selezionato? Il contenuto dell'area di lavoro verrà sostituito
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="px-2">
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click.native.stop="confirmDialog = false">Annulla</v-btn>
                    <v-btn color="info" text @click.native="setTemplate()">Conferma</v-btn>
                </v-card-actions>                
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>

    import Vue from 'vue'
    import { button } from './button'
    import { unsubscribedBlock } from './unsubscribedBlock'
    import { socialLinkBlock } from './socialLinkBlock'
    import grapesjs from 'grapesjs';
    import it from 'grapesjs/locale/it'
    import en from 'grapesjs/locale/en'
    import 'grapesjs/dist/css/grapes.min.css'
    import 'grapesjs-preset-newsletter/dist/grapesjs-preset-newsletter.css'
    import 'grapesjs-preset-newsletter/dist/grapesjs-preset-newsletter.min.js'
    import 'grapesjs-plugin-social/dist/grapesjs-plugin-social.min.js'
    // import 'grapesjs-plugin-ckeditor/dist/grapesjs-plugin-ckeditor.min.js'
    import GrapesConfig from '@/components/modules/mailmarketing/GrapesConfig.js'

    export default {
        name: 'grapes-editor',
        props: {
            id: Number
        },

        data() {
            return {
                paths: [],
                model: {},
                editor: {},
                dialog: false,
                variables: [],
                storageManager: {},
                defaultTemplates: [],
                confirmDialog: false,
                templateVariables: '',
                templateSelected: null,
                idToLoad: this.id,
                variablesLoad: false,
            }
        },

        computed: {

            modelSelected() {
                if(this.templateSelected != null && this.defaultTemplates[this.templateSelected] && this.defaultTemplates[this.templateSelected].name) {
                    return this.defaultTemplates[this.templateSelected]
                }
                return ''
            }
        },        

        methods: {

            getFiles() {

                return new Promise((resolve, reject) => {
 
                    let data = {
                        id: this.id,
                        attachable_type: 'template',
                    }
                    this.axios.post('attachmentslists/', data).then(response => {
                        // get body data
                        _.forEach(response.data.attachments, (attachment) => {
                            this.paths.push(this.$store.getters.baseUrl + '/api/publicfiles/' + attachment.path)
                        })

                        resolve('success')

                    }, response => {
                        // error callback
                        reject('error retrive attachments')
                    })
                })
            },

            getTemplates() {

                return new Promise((resolve, reject) => {

                    this.axios.get('templates-mailmarketing-defaults/').then(response => {
                        // get body data
                        _.forEach(response.data.data, (template) => {
                            template.options = JSON.parse(template.options)
                            this.defaultTemplates.push(template)
                        })

                        resolve('success')

                    }, response => {
                        // error callback
                        reject('error retrive templates')
                    })
                })
            },


            closeDialog() {
                this.dialog = false
                this.templateSelected = null
            },


            confirmSelected() {
                this.confirmDialog = true
                this.idToLoad = this.modelSelected.id
            },


            setTemplate() {
                this.editor.load()
            },
        },

        mounted() {
            let self = this
            Promise.all([this.getFiles(), this.getTemplates()]).then(() => {

                this.editor = grapesjs.init({
                    panels: GrapesConfig,
                    height: '100%',
                    storageManager: {type: 'yello'},
                    assetManager: {
                        assets: self.paths,

                        uploadFile: function(e) {

                            let files = e.dataTransfer ? e.dataTransfer.files : e.target.files
                            let file = files && files[0]
                            if (!file) return

                            const data = new FormData()
                            
                            data.append('file',  file, file.name)
                            data.append('attachable_type', 'template')
                            data.append('attachable_id', self.id)
                            data.append('public', 1)
                            // stesso flag di ImagePicker: senza, il backend non ottimizza l'immagine
                            data.append('usage', 'email_image')

                            self.axios.post('attachments/', data).then(response => {
                                // add attachment to assetManager
                                self.editor.AssetManager.add(self.$store.getters.baseUrl + '/api/publicfiles/' + response.data.data.path)
                            }, response => {
                                // error callback
                            })
                        },
                        uploadText: 'Uploading is not available in this demo',
                    },
                    i18n: {
                        messages: { it },
                    },
                    container : '#gjs',
                    fromElement: true,
                    plugins: ['gjs-preset-newsletter'],
                    // plugins: ['gjs-preset-newsletter', 'gjs-plugin-ckeditor'],
                    // plugins: ['gjs-preset-newsletter', 'gjs-social'],
                    pluginsOpts: {
                        'gjs-preset-newsletter': {
                            modalLabelImport: 'Incolla tutto il tuo codice qui sotto e fai clic su Importa',
                            modalLabelExport: 'Copia il codice e usalo dove vuoi',
                            codeViewerTheme: 'material',
                            modalTitleImport: 'Importa template',
                            modalBtnImport: 'Importa',
                            importPlaceholder: '<table class="table"><tr><td class="cell">Hello world!</td></tr></table>',
                            cellStyle: {
                                'font-size': '12px',
                                'font-weight': 300,
                                'vertical-align': 'top',
                                color: 'rgb(111, 119, 125)',
                                margin: 0,
                                padding: 0,
                            }
                        },
                        // 'gjs-plugin-ckeditor': {options: {language: 'it'}, position: 'center'}
                    },
                })
                this.editor.on('load', () => {
                    this.editor.StyleManager.addSector('mySector',{
                        name: 'Posizionamento',
                        open: false,
                        buildProps: ['float', 'display', 'position', 'top', 'right', 'left', 'bottom'],                        
                        properties:[
                            {
                                name: 'Alignment',
                                property: 'float',
                                type: 'radio',
                                defaults: 'none',
                                list: [
                                    { value: 'none', className: 'fa fa-times'},
                                    { value: 'left', className: 'fa fa-align-left'},
                                    { value: 'right', className: 'fa fa-align-right'}
                                ],
                            },
                            {
                                property: 'position',
                                type: 'select'
                            }
                        ],
                        properties:[
                            {
                                name: 'Display',
                                property: 'display',
                                type: 'select',
                                defaults: 'none',
                                list: [
                                    { value: 'block', name: 'block'},
                                    { value: 'inline', name: 'inline'},
                                    { value: 'inline-block', name: 'inline-block'},
                                    { value: 'none', name: 'none'},
                                ],
                            },
                            {
                                property: 'position',
                                type: 'select'
                            }
                        ]   
                        }, { at: 1 }
                    )

                    let fontProperty = this.editor.StyleManager.getProperty('typography', 'font-family')
                    var list = [];
                    fontProperty.set('list', list);
                    list = [
                        fontProperty.addOption({value: "Arial, Helvetica, sans-serif", name: 'Arial'}),
                        fontProperty.addOption({value: "Courier New, Courier, monospace", name: 'Courier New'}),
                        fontProperty.addOption({value: "Georgia, serif", name: 'Georgia'}),
                        fontProperty.addOption({value: "Helvetica, sans-serif", name: 'Helvetica'}),
                        fontProperty.addOption({value: "Impact, Charcoal, sans-serif", name: 'Impact'}),
                        fontProperty.addOption({value: "Tahoma, Geneva, sans-serif", name: 'Tahoma'}),
                        fontProperty.addOption({value: "Times New Roman, Times, serif", name: 'Times New Roman'}),
                        fontProperty.addOption({value: "Verdana, Geneva, sans-serif", name: 'Verdana'}),
                    ]
                    fontProperty.set('list', list)
                    this.editor.StyleManager.render()
                })

                const panelManager = this.editor.Panels
                panelManager.addButton('options', [
                    {
                        id: 'undo',
                        className: 'fa fa-undo',
                        attributes: {title: 'Annulla'},
                        command: () => {this.editor.runCommand('core:undo')}
                    },
                    {
                        id: 'redo',
                        className: 'fa fa-repeat',
                        attributes: {title: 'Ripeti'},
                        command: () => {this.editor.runCommand('core:redo')}
                    },
                    {
                        id: 'clear-all',
                        className: 'fa fa-trash icon-blank',
                        attributes: {title: 'Cancella tutto'},
                        command: {
                            run: function(editor, sender) {
                                sender && sender.set('active', false)
                                if(confirm('Sei sicuro di voler eliminare tutto?')) {
                                    editor.DomComponents.clear()
                                }
                            }
                        }
                    },
                    {
                        id: 'template',
                        className: 'fa fa-newspaper-o',
                        attributes: {title: 'Modelli'},
                        command: () => {self.dialog = true}
                    },
                ])

                this.templateVariables = '<select class="gjs-field" style="width: 150px; color: white; height: 30px; padding-left: 8px;"><option value="" style="height: 30px; color: black;"> Variabili</option>'

                this.editor.StorageManager.add('yello', {
                    /**
                     * Load the data
                     * @param  {Array} keys Array containing values to load, eg, ['gjs-components', 'gjs-style', ...]
                     * @param  {Function} clb Callback function to call when the load is ended
                     * @param  {Function} clbErr Callback function to call in case of errors
                     */
                    load(keys, clb, clbErr) {


                        Vue.axios.get('templates-mailmarketing/' + self.idToLoad + '/edit').then(response => {
                            let body = JSON.parse(response.data.model.body)
                            let result = {}

                            keys.forEach(key => {
                                if (body && body[key]) {
                                    result[key] = body[key]
                                }
                            })

                            clb(result)

                            if(!self.variablesLoad) {

                                self.variables = response.data.fields.fields.filter((field) => { return field.type == 'email_variables'})
                                self.variables = self.variables[0].variables

                                self.variables.forEach(key => {
                                    self.templateVariables += '<option value="{{'+ key +'}}" style="height: 30px; color: black;">'+key+'</option>'
                                })
                                self.templateVariables += '</select>'

                                self.editor.RichTextEditor.add('custom-vars', {
                                    icon: self.templateVariables,
                                        // Bind the 'result' on 'change' listener
                                    event: 'change',
                                    result: (rte, action) => rte.insertHTML(action.btn.firstChild.value),
                                    // Reset the select on change
                                    update: (rte, action) => { action.btn.firstChild.value = ''}
                                })
                                self.variablesLoad = true
                            }


                            // self.editor.addComponents('<style>.yButton { text-align:center; vertical-align: middle; height: 45px; margin: 0 0 0 0; padding: 12px 42px 12px 42px; display: inline-block; font-size: 16px; font-weight: 700; color: #ffffff; background-color: #009fc7; width: 200px; border-radius: 4px 4px 4px 4px; text-decoration: none } div[data-gjs-type="text"] {word-break: break-word !important;}</style>')

                             // for set template
                            self.dialog = false
                            self.confirmDialog = false
                            self.idToLoad = self.id

                        })
                    },

                    /**
                     * Store the data
                     * @param  {Object} data Data object to store
                     * @param  {Function} clb Callback function to call when the load is ended
                     * @param  {Function} clbErr Callback function to call in case of errors
                     */
                    store(data, clb, clbErr) {
                        self.model.body = JSON.stringify(data)
                        Vue.axios.put('templates-mailmarketing/' + self.id, self.model).then(response => {
                            clb()
                        })
                    }
                })


                this.editor.load()

                this.editor.BlockManager.add('unsubscribed-button', {
                    label: 'Disiscriviti',
                    content: '<a href="{{UNSUBSCRIBED}}" target="_blank" class="button" style="box-sizing: border-box;">Disiscrivimi</a>',
                    attributes: {
                        class: 'gjs-fonts gjs-f-button'
                    }
                })

                this.editor.BlockManager.add('tracking-preferences-button', {
                    label: 'Tracciamento',
                    content: '<a data-tracking-notice="1" href="{{TRACKING_PREFERENCES}}" target="_blank" class="button" style="box-sizing: border-box;">Disattiva il tracciamento</a>',
                    attributes: {
                        class: 'gjs-fonts gjs-f-button'
                    }
                })

                this.editor.BlockManager.add('unsubscriber-footer', {
                    label: 'Footer',
                    content: unsubscribedBlock,
                    attributes: {
                        class: 'fa fa-sticky-note-o'
                    }
                })

                this.editor.BlockManager.add('social-link', {
                    label: 'Social Link',
                    content: socialLinkBlock,
                    attributes: {
                        class: 'fa fa-share-alt'
                    }
                })

                this.editor.BlockManager.get('button').set({
                    label: 'Button',
                    content: button,
                    attributes: {
                        style: {
                            'text-align': 'center',
                            'vertical-align': 'middle',
                            'height': '45px',
                            'margin': '0 0 0 0',
                            'padding': '12px 42px 12px 42px',
                            'display': 'inline-block',
                            'font-size': '16px',
                            'font-weight': '700',
                            'color': '#ffffff',
                            'background-color': '#009fc7',
                            'width': '200px',
                            'border-radius': '4px 4px 4px 4px',
                            'text-decoration': 'none',
                        },
                        class: 'gjs-fonts gjs-f-button'
                    }
                })

            })

        }
    }
</script>